<template>
  <div class="particulars">
    <a-modal
      :width="width"
      :visible="visibleShow"
      title="问卷信息"
      @cancel="handleCancel"
    >
      <div slot="footer"></div>
      <div v-for="(item, index) in particulars" :key="index" class="details">
        <p class="wname">
          {{ index + 1 }}、{{ item.questionContent }}
          <span v-if="item.optionType == 2">(多选)</span>
          <span v-else>(单选)</span>
        </p>
        <div v-for="(list, index) in item.options" :key="index">
          <p class="content">
            <span> {{ list.optionNumber }}. </span>{{ list.optionContent }}({{
              list.score
            }}分)
          </p>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    particulars: {
      type: Array,
      require: true
    }
  },
  data() {
    return {
      visibleShow: false,
      width: 1000,
      wname: ''
    };
  },
  methods: {
    handleCancel() {
      this.visibleShow = false;
    }
  }
};
</script>

<style lang="less">
.wname {
  margin-top: 15px;
  margin-bottom: 15px;
  font-weight: 700;
}
.content {
  margin-bottom: 10px;
  span {
    font-weight: 700;
  }
}
.details {
  p {
  }
}
</style>
